import { Card, CardBody, Col, Row } from 'reactstrap'
import DarkBackgrounds from './DarkBackgrounds'
import LightBackgrounds from './LightBackgrounds'
import ExtendedBackgroundColors from './ExtendedBackgroundColors'
import { BackgroundColors } from '../../../../Utils/Constants'
import { backgroundData } from '../../../../Data/Ui-Kits/HelperClasses/HelperClassesData'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const BackgroundColorsCart = () => {
  return (
    <Col xs="12">
      <Card>
        <CardHeaderCommon title={BackgroundColors} span={backgroundData} headClass="card-no-border pb-0"/>
        <CardBody>
          <Row className="g-3">
            <DarkBackgrounds />
            <LightBackgrounds />
            <ExtendedBackgroundColors />
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export default BackgroundColorsCart